import { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";

import DashPage from "../dash/DashPage";
import NotFoundPage from "../error/NotFoundPage";
import KmosView2 from "./v2.0/KmosView";
import { SessionContext } from "../../utility/useSession";
import { ReleaseFlag, useReleaseManagement } from "../../utility/feature-management";
import { LaneAllocationSystem } from "../../logic/api";


const KmosPage = () => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();
  const isSydneyDualParkAllocationReleased = useReleaseManagement(ReleaseFlag.releaseSydneyDualParkAllocation);

  if (session.current.site == null) {
    return <Fragment></Fragment>;
  }

  if (isSydneyDualParkAllocationReleased) {
    if (![LaneAllocationSystem.KMOS, LaneAllocationSystem.DAS].includes(session.current.site.preferences.lane_allocation_system)) {
      return <NotFoundPage title={t("notFoundPage.notAvailable")} message={t("notFoundPage.featureNotEnabled")} />
    }
  }

  return (
    <DashPage>
      <KmosView2 />
    </DashPage>
  )
}

export default KmosPage;
